export default function persistentSvg() {
    return <img src="images/persistent.jpg" />;
}
